module.exports = __webpack_public_path__ + "static/media/dbc.6877d455.svg";